<template>
  <div id="app">
    <!-- {{onlineStatus}} -->
    <router-view/>
  </div>
</template>
<script>
// const electron = window.require("electron")
import { register } from 'register-service-worker'

export default {
  mounted() {
    // electron.ipcRenderer.on('goToHome', ()=>{
    //   this.$router.push('/');
    // });
    // electron.ipcRenderer.on('goToAbout', ()=>{
    //   this.$router.push('/about');
    // });
    // electron.ipcRenderer.on('online-status-changed',(status) => {
    //   console.log(status)
    // })
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready () {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
      },
      registered () {
        console.log('Service worker has been registered.')
      },
      cached () {
        console.log('Content has been cached for offline use.')
      },
      updatefound () {
        console.log('New content is downloading.')
      },
      updated () {
        console.log('New content is available; please refresh.')
      },
      offline () {
        // localStorage.removeItem('Delivery-Software-PWA-Prompt')
        console.log('No internet connection found. App is running in offline mode.')
      },
      error (error) {
        localStorage.removeItem('Delivery-Software-PWA-Prompt')
        console.error('Error during service worker registration:', error)
      }
    })

    //detect app installed
    window.addEventListener('appinstalled', () => {
      localStorage.setItem('Delivery-Software-PWA-Prompt',true)
      this.$router.push({ name : 'home'})
      return
    });

    window.addEventListener('online', () => {
      this.$router.push({ name : 'home'})
      return
    })

    window.addEventListener('offline', ()  => {
      this.$router.push({ name : 'offline'})
      return
    })
    // console.log(this.$route.name)
    if(navigator.onLine){
      if(this.$route.name != 'home'){
        this.$router.push({ name : 'home'})
      }
    }else{
      if(this.$route.name != 'offline'){
        this.$router.push({ name : 'offline'})
      }
    }

    if(window.localStorage.getItem('download_url')){
        // this.$swal({
        //   icon: 'warning',
        //   title: 'New version detected',
        //   text: 'Please update to latest version application',
        //   showCancelButton: true,
        //   confirmButtonColor: '#ff6700',
        //   confirmButtonText: "Download",
        //   cancelButtonText: "Continue",
        //   allowOutsideClick: false,
        //   reverseButtons: true,
        //   allowEscapeKey: false
        // }).then(res => {
        //   if(res.isConfirmed == true){
        //     window.require('electron').shell.openExternal(window.localStorage.getItem('download_url'))
        //   }
        // })
    }    
  },
  data(){
    return {
      // onlineStatus: navigator.onLine ? 'online' : 'offline'
    }
  },
  methods:{

  },
  computed:{

  }
}

</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.home{
  height: 100%; 
}

@import'~bootstrap/dist/css/bootstrap.css'
</style>
